// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationOutlinedSvg from "@ant-design/icons-svg/es/asn/ReconciliationOutlined";
import AntdIcon from '../components/AntdIcon';

var ReconciliationOutlined = function ReconciliationOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationOutlinedSvg
  }));
};

ReconciliationOutlined.displayName = 'ReconciliationOutlined';
export default React.forwardRef(ReconciliationOutlined);